import { useNavigate } from "react-router-dom";

import { useGetMyAttemptsQuery } from "../../slices/quizAttemptApiSlice";

import AttemptHistoryTable from "./components/AttemptHistoryTable";

const MyAttemptsScreen = () => {
  const navigate = useNavigate();

  const { data, isLoading, isError } = useGetMyAttemptsQuery();

  const attempts = Array.isArray(data) ? data : data?.attempts || [];

  const handleViewAttempt = (attemptId) => {
    if (!attemptId) {
      return;
    }

    navigate(`/quiz-attempts/${attemptId}`);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">Loading attempts...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-800">
            Unable to load attempts
          </h2>

          <p className="text-gray-500 mt-2">Please try again later.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-6xl mx-auto space-y-6">
        {/* Header */}

        <div className="bg-white rounded-lg border p-5">
          <h1 className="text-2xl font-bold text-gray-800">My Quiz Attempts</h1>

          <p className="text-gray-500 mt-1">
            Review your previous quiz performances
          </p>
        </div>

        {/* Attempt History */}

        <AttemptHistoryTable
          attempts={attempts}
          onViewAttempt={handleViewAttempt}
        />
      </div>
    </div>
  );
};

export default MyAttemptsScreen;
